import { useMemo } from "react";
import "../../../style/upcomingHolidays.css";

export default function UpcomingHolidaySide({ holidayList = [] }) {
  const upcomingHolidays = useMemo(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    return holidayList
      .filter(h => {
        if (!h.holidayDate) return false;

        const d = new Date(h.holidayDate);

        return (
          d.getMonth() === currentMonth &&
          d.getFullYear() === currentYear &&
          d >= today // upcoming only
        );
      })
      .sort(
        (a, b) =>
          new Date(a.holidayDate) -
          new Date(b.holidayDate)
      );
  }, [holidayList]);

  return (
    <div className="holiday-card" style={{height:"260px"}}>
      {/* Header */}
      <div className="holiday-header">
        <div className="icon-box">📅</div>
       <div>
    <h5 className="mb-1 fw-semibold">
      Upcoming Holidays
    </h5>
    <p className="text-muted small mb-0">
      Plan your leaves
    </p>
  </div>
      </div>

      {/* List */}
      <div className="holiday-list">
        {upcomingHolidays.length === 0 && (
          <p className="empty-text">
            No upcoming holidays this month
          </p>
        )}

        {upcomingHolidays.map((holiday, index) => (
          <div
            className={`holiday-item color-${index % 5}`}
            key={index}
          >
            <div className="holiday-date">
              {new Date(holiday.holidayDate).toLocaleDateString(
                "en-US",
                {
                  weekday: "short",
                  day: "2-digit",
                  month: "short",
                  year: "numeric"
                }
              )}
            </div>

            <div className="holiday-name">
              {holiday.holidayName}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
